<template>
    <div id="legalRule" data-role="page">
        <!-- content -->
        <div class="legalRule-content" data-position="fixed">
            <div class="detailWrap">
                <div class="detail-h">
                    <h3>公寓大廈管理條例</h3>
                </div>
                <div class="detail-c">
                    <ul class="collapse-ul-list rule-list">
                        <li :id="'Wrap'+rule_ind" v-for="(rule,rule_ind) in Rules" v-on:click="openWrap(rule_ind)" :key="rule_ind">
                            <a class="title">
                                <div class="info">
                                    <h4>{{rule.rule_name}}</h4>
                                </div>
                                <i class="icon-dropdown triggerIcon"></i>
                            </a>
                            <div class="triggerWrap">
                                <ul class="collapse-ul-sublist">
                                    <li v-for="(cont,cont_ind) in rule.ruleList" :key="cont_ind"><router-link :to="{name:'legalRuleDetail',params: { id : cont.rule_id}}" >{{cont.rule_name}}</router-link></li>
                                </ul>
                            </div>
                        </li>               
                    </ul>
                </div>
            </div>
            <div class="detailWrap extraWrap">
                <div class="detail-h">
                    <h3>法律沿革</h3>
                </div>
                <div class="detail-c">
                    <ul id="" class="">
                        <li>中華民國 84年6月28日總統華總(一)義字第4316號令制定公布全文52條</li> 
                        <li>中華民國89年4月26日總統華總一義字第8900104430號令修正公布第2條條文</li> 
                        <li>中華民國92年12月31日總統華總一義字第09200243911號令修正公布全文6 3條，並自公布日施行</li> 
                        <li>中華民國95年1月18日總統華總一義字第09500005871號令修正公布第29條；增訂第59條之1條文(中華民國101年6月25日行政院院臺規字第101013 4960 號公告第17條第1項所列屬「財政部」之權責事項，經行政院公告 自93年7月1日起變更為「行政院金融監督管理委員會」管轄，自101年7 月1日起改由「金融監督管理委員會」管轄)</li> 
                        <li>中華民國102年5月8日總統華總一義字第 10200082711號令修正公布第8條 、第27條條文</li> 
                        <li>中華民國105年11月16日總統華總一義字第10500140111號令修正公布第 8 條及第18條條文</li> 
                    </ul>
                </div>
            </div>
        </div>
        <!-- /content -->

    </div>
</template>

<script lang="js">
export default {
  data () {
    return {
      Rules:[],
    }
  },
  mounted(){ 
      this.GetlegalRuleList();
  },
  methods:{
      openWrap(e){
          let thisWrap = $("#Wrap"+e);
          thisWrap.hasClass("active") ? thisWrap.removeClass('active') : thisWrap.addClass('active')
      },
      GetlegalRuleList(){
        var vobj = this;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeLegalRuleAbout`,{
            headers:{Authorization: Token}
        }).then((response) => {
            if(response.status == 200){
            vobj.Rules =  response.data.data
            console.log(vobj.Rules);
            }else{

            }
        })
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/legalRule.vue